export const ArrowDown = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.2845 1.07031V6.71255M4.2845 6.71255L7.10562 3.89143M4.2845 6.71255L1.46338 3.89143"
      stroke="#F04438"
      stroke-width="1.20905"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
